export const getInitial = (name) => {
  if (name) {
    const parts = name?.split(" ");
    const firstName = parts[0];
    const initial = firstName ? firstName.charAt(0).toUpperCase() : "";
    return initial;
  } else {
    return "";
  }
}

export function shortenParagraph(text, maxLength) {
  if (text?.length <= maxLength) {
    return text;
  }
  return text?.slice(0, maxLength).trim() + '....';
}